var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(_vm.logoStyle),attrs:{"src":_vm.currentSrc,"alt":_vm.alt},on:{"error":_vm.handleError}})}
var staticRenderFns = []

export { render, staticRenderFns }